import { createCustomToggle, updateOnScroll, lineupButtonsGrid } from '../js/helpers/helpers';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  createCustomToggle();
  contentMarginTop();
  fixFeatureButton();
});

// Calculate content margin top
function contentMarginTop() {
  function updateContentMargin() {
    const headerHeight = $('header')[0].getBoundingClientRect().height;
    const isHomepage = $('body').hasClass('homepage');
    const generalMessageHeight = $('.generalmessage').length
      ? $('.generalmessage').outerHeight()
      : 0;
    const isMobile = $(globalThis).innerWidth <= 1100;

    let marginTop = headerHeight;
    updateOnScroll(generalMessageHeight);

    if (!isHomepage && !isMobile) {
      marginTop += 40;
    }

    $('.content').css('margin-top', marginTop + 'px');
  }

  $(document).ready(updateContentMargin);
  $(globalThis).on('load scroll resize', updateContentMargin);
}

// Style Feature Button
function fixFeatureButton() {
  $('.featureLineupContainer').each((i, element) => {
    lineupButtonsGrid($(element));
  });
}
